export default "__VITE_ASSET__DnNeWDaR__"